import gql from "graphql-tag";
import { defineStore } from "pinia";

import { apollo } from "@/utils/apollo.ts";

export const useChannelsStore = defineStore("channels", {
  state: () => ({
    all: <
      {
        created_at: string
        id: string
        locale: string
        name: string
        platform: string
        status: "ACTIVE" | "INACTIVE"
        __typename: string
        country: {
          id: string
          name: string
          __typename: string
        }
      }[]
    >[],
  }),
  getters: {
    getChannels({ all }) {
      return all;
    },
  },
  actions: {
    setChannels(channels = []) {
      this.all = channels;
    },

    async fetchAll(params = {}) {
      const { data } = await apollo.query({
        query: gql`
            query channels(
              $page: Int
              $limit: Int
              $search: String
              $isActive: Boolean
            ) {
              getChannels(
                page: $page
                limit: $limit
                search: $search
                isActive: $isActive
              ) {
                from
                total
                to
                current
                perPage
                next
                previous
                data {
                  id
                  name
                  platform
                  locale
                  status
                  created_at
                  country {
                    id
                    name
                  }
                }
              }
            }
          `,
        variables: {
          limit: 100,
          isActive: true,
          ...params,
        },
      });
      this.all = data.getChannels.data;
    },
    updateChannel(id: string | number, isActive: boolean) {
      return apollo.mutate({
        mutation: gql`
          mutation updateChannel($id: ID!, $data: UpdateChannelInput!) {
            updateChannel(id: $id, data: $data) {
              id
            }
          }
        `,
        variables: {
          id: +id,
          data: { status: isActive },
        },
      });
    },
    clearStore() {
      this.all = [];
    },
    // fetchFilter(params = {}) {
    //   return new Promise((resolve, reject) => {
    //     apollo
    //       .query({
    //         query: CHANNELS_FILTER_QUERY,
    //         variables: {
    //           ...params,
    //           limit: 100,
    //           isActive: true,
    //         },
    //       })
    //       .then((response) => {
    //         this.setChannels(
    //           response.data.getChannels.data.map((channel: any) => ({
    //             ...channel,
    //             id: +channel.id,
    //             label: channel.name,
    //           })),
    //         );
    //         resolve(response);
    //       })
    //       .catch((error) => reject(error));
    //   });
    // },
  },
});
